import Player from '@vimeo/player';
import { csrfToken } from 'rails-ujs';
import { getSilverEggDomain, getAigentCookieId, determinePlatformKind } from '../scripts/front/aigent_common.js';

const preview = (location.href.match(/key/)) ? true : false; // previewキーの有無
const interval = 10 * 1000; // timer interval: 10 seconds
const CV_REQUIRED_SECONDS = 30; // CV判定の閾値（秒）

$(function() {
  initialize();
});

function initialize() {
  $("iframe[id^=player]").each(function() {
    const iframe = $(this);
    const movieId = iframe.data("movie_id");
    const contentId = iframe.data("content_id");
    const playerId = iframe.attr("id");
    const player = new Player(playerId);

    // サンプル視聴ボタンクリック時（このmovieIdに対応するボタンのみ）
    $(`.video-sample-btn[data-movie_id="${movieId}"]`).on("click", function() {
      // 価格体系導線オーバーレイを非表示
      $(`#pricing_flow_overlay_pc_${movieId}`).hide();
      $(`#pricing_flow_overlay_sp_${movieId}`).hide();
      // サンプル動画を再生
      player.play();
    });

    // 目次クリック時 seek at the specified time
    $(".toc_time").on("click", function(e) {
      e.preventDefault();

      // timeText (hh:mm:ss) ex. '1:23:45'
      const timeText = $(this).data('time');
      const [ss = 0, mm = 0, hh = 0]
        = timeText.split(':').map(it => parseInt(it)).reverse();
      // conversion of hours, minutes and seconds to seconds
      const seconds = [ss, (mm * 60), (hh * 60 * 60)]
        .reduce((sum, it) => { return sum + it }, 0);

      player.setCurrentTime(seconds);
    });

    setupPlayerEvents({
      movieId: movieId,
      contentId: contentId,
      loggedId: null,
      player: player,
      timerId: null,
      cvRequested: false,
    });
  });
}

function setupPlayerEvents(playerObj) {
  const { movieId, player } = playerObj;

  // 設定再生位置
  player.setCurrentTime(Number($(`#current_time_${movieId}`).val()));

  // イベントリスナー設定
  window.addEventListener("beforeunload", () => {
    player.pause();
  });
  window.addEventListener("pagehide", () => {
    player.pause();
  });

  // 再生を開始した時
  player.on("play", function() {
    createLogData(playerObj);
    clearTimer(playerObj);
    setTimer(playerObj);
  });

  // 再生を一時停止した or 再生が終了した時
  //
  // NOTE:
  // - 価格体系導線のオーバーレイは、PC/SP で別々の要素としてrenderされる
  //   - PC版: div#pricing_flow_overlay_pc_${movieId}
  //   - SP版: div#pricing_flow_overlay_sp_${movieId}
  // - サンプル視聴開始時にこれらを非表示にし、pause時に再度表示することで
  //   「動画上に導線が戻る」既存仕様を維持する
  player.on("pause", function() {
    const pcOverlayId = `pricing_flow_overlay_pc_${movieId}`;
    const spOverlayId = `pricing_flow_overlay_sp_${movieId}`;
    const pcOverlay = document.getElementById(pcOverlayId);
    const spOverlay = document.getElementById(spOverlayId);
    if (pcOverlay) pcOverlay.style.display = "";
    if (spOverlay) spOverlay.style.display = "";

    updateLogData(playerObj);
    clearTimer(playerObj);
  });
}

function setTimer(playerObj) {
  playerObj.timerId = setInterval(() => updateLogData(playerObj), interval);
}

function clearTimer(playerObj) {
  if (!playerObj.timerId) return;
  clearInterval(playerObj.timerId);
  playerObj.timerId = null;
}

function createLogData(playerObj) {
  const { movieId, loggedId } = playerObj;

  // 一度送信済み or プレビュー表示の場合は送信しない
  if (loggedId || preview) return;

  $.ajax({
    type: "POST",
    url: "/api/log_movies",
    headers: {
      "X-CSRF-Token": csrfToken(),
    },
    data: {
      movie_id: movieId,
    },
    success: function(data) {
      playerObj.loggedId = data["log_id"];
    },
    async: false,
    timeout: 10000,
  });
}

function updateLogData(playerObj) {
  const { player, loggedId } = playerObj;
  if (player == null || loggedId == null || preview) return;

  player.getPlayed().then(function(played) {
    if (played == null || played.length == 0) return;

    const durations = played.map((range) => range[1] - range[0]);
    const endPoints = played.map((range) => range[1]);
    const duration = durations.reduce((sum, duration) => sum + duration, 0);
    const currentTime = Math.max(...endPoints);

    $.ajax({
      type: "PUT",
      url: `/api/log_movies/${loggedId}`,
      headers: {
        "X-CSRF-Token": csrfToken(),
      },
      data: {
        duration: duration,
        current_time: currentTime,
      },
      async: false,
      timeout: 10000,
    });

    // ===== 30秒視聴判定（updateLogData()と同等の計測方法） =====
    if ((duration >= CV_REQUIRED_SECONDS) && !playerObj.cvRequested) {
      sendAigentCVRequest(playerObj);
    }
  });
}

// ===== 画像ビーコン方式でCVリクエスト送信（Promise + タイムアウト付き） =====
function sendCVBeacon(url, timeoutMs = 1000) {
  return new Promise((resolve) => {
    const img = new window.Image();
    let settled = false;
    const done = () => {
      if (!settled) {
        settled = true;
        resolve();
      }
    };
    img.onload = done;
    img.onerror = done;
    img.src = url;
    setTimeout(() => {
      console.warn('[vimeo.js] CVリクエスト送信タイムアウト');
      done();
    }, timeoutMs);
  });
}

async function sendAigentCVRequest(playerObj) {
  try {
    const merch = 'doctorbookac';
    const cust = getAigentCookieId(); // cust(ユーザID)にCookieID(暗号化ユーザID)と同値を設定
    const platformKind = determinePlatformKind();
    const devicePlatformMap = { pc: 'p', sp: 's' };
    const device = devicePlatformMap[platformKind];
    const prod = playerObj.contentId;
    const sku = playerObj.movieId;
    const order = `${cust}_${playerObj.loggedId}`;

    if (!cust || !device || !prod || !sku) return;

    const queryParams = {
      // 数量, 価格はAIおすすめで取り扱わない為、固定値1としている
      prod, merch, sku, order, qty: 1, price: 1, cust, cookie: cust, device
    };

    const baseUrl = `https://${getSilverEggDomain()}/pycre5/jsonp/purchase`;
    const url = `${baseUrl}?${new URLSearchParams(queryParams).toString()}`;

    // デバッグ用
    console.info('[vimeo.js] Aigent CVリクエスト送信:', url);
    await sendCVBeacon(url, 1000);
    playerObj.cvRequested = true;
  } catch (e) {
    console.error('[vimeo.js] Aigent CVリクエスト送信失敗', e);
    playerObj.cvRequested = true;
  }
}
